import { useStaticQuery, graphql } from 'gatsby';

export const useHotelPages = (hotelUUIDs) => {
  const { allStoryblokEntry } = useStaticQuery(graphql`
    query HotelQuery {
      allStoryblokEntry(filter: { field_component: { eq: "hotel_page" } }) {
        nodes {
          uuid
          field_hotel_id_string
          field_listing_text_string
          sts_hotel: field_sts_hotel_boolean
          full_slug
          lang
          field_coming_soon_boolean
          translated_slugs {
            lang
            path
          }
        }
      }
    }
  `);

  const nodes = allStoryblokEntry.nodes
    .filter((hotelPage) => {
      return (
        hotelPage.lang === process.env.GATSBY_STORYBLOK_LANGUAGE &&
        hotelUUIDs.includes(hotelPage.uuid)
      );
    })
    .sort((a, b) => {
      return hotelUUIDs.indexOf(a.uuid) - hotelUUIDs.indexOf(b.uuid);
    });

  return nodes;
};
